import styled from 'styled-components';

/*
 * The widget's own failure surface. Deliberately plain text rather than a card: it stands in for a
 * payment sheet that did not arrive, and dressing it up as one invites a tap that has nothing behind it.
 */
export const PaymentUnavailable = styled.p`
  margin: 0;
  padding: 16px 0;
  font-family: ${({ theme }) => theme.fonts.join()};
  font-size: 14px;
  line-height: 1.4;
  color: ${({ theme }) => theme.colors.greys.adminGreyDark};
`;
